const addInfo = {
  title: 'Driver',
  icon: 'driver'
}
const driverRouter = {
  path: '/driver',
  meta: {
    title: 'Driver',
    icon: 'driver',
    permission: ['driver_management']
  },
  children: [
    {
      path: 'manage-driver',
      component: () => import('@/views/driver/ManageDriver/manage-driver'),
      name: 'ManageDriver',
      meta: { title: 'Driver', parent: addInfo,  permission: ['driver_enable'] }
    },
    {
      path: 'create-driver-form/:id?',
      component: () => import('@/views/driver/ManageDriver/manage-driver-form'),
      name: 'DriverForm',
      hidden: true,
      meta: { 
        title: 'ManageDriverForm', 
        parent: addInfo, 
        activeMenu: '/driver/manage-driver', 
        enableBack: true, 
        backPage: 'ManageDriver', 
        permission: ['driver_create'] }
    },
    {
      path: 'update-driver-form/:id?',
      component: () => import('@/views/driver/ManageDriver/manage-driver-form'),
      name: 'UpdateDriverForm',
      hidden: true,
      meta: { 
        title: 'ManageDriverForm', 
        parent: addInfo, 
        activeMenu: '/driver/manage-driver', 
        enableBack: true, 
        backPage: 'ManageDriver', 
        permission: ['driver_update'] }
    },
    {
      path: 'driver-details/:id',
      component: () => import('@/views/driver/ManageDriver/driver-details'),
      name: 'DriverDetails',
      hidden: true,
      meta: { title: 'DriverDetails', parent: addInfo, activeMenu: '/driver/manage-driver', enableBack: true, backPage: 'ManageDriver', permission: ['driver_enable'] }
    },
    // {
    //   path: 'driver-inquiry',
    //   component: () => import('@/views/driver/DriverInquiry/driver-inquiry'),
    //   name: 'DriverInquiry',
    //   meta: { title: 'DriverInquiry', parent: addInfo }
    // },
    // {
    //   path: 'driver-app',
    //   name: 'DriverApp',
    //   meta: { title: 'DriverApp', parent: addInfo },
    //   children: [
    //     {
    //       path: 'check-in-out',
    //       component: () => import('@/views/driver/DriverApp/check-in-out'),
    //       name: 'CheckInOut',
    //       meta: { title: 'CheckInOut', parent: addInfo }
    //     },
    //     {
    //       path: 'checklist-approval',
    //       component: () => import('@/views/driver/DriverApp/checklist-approval'),
    //       name: 'ChecklistApproval',
    //       meta: { title: 'ChecklistApproval', parent: addInfo }
    //     },
    //     {
    //       path: 'driver-claim-report',
    //       component: () => import('@/views/driver/DriverApp/driver-claim-report'),
    //       name: 'DriverClaimReport',
    //       meta: { title: 'DriverClaimReport', parent: addInfo }
    //     },
    //     {
    //       path: 'driver-tracing',
    //       component: () => import('@/views/driver/DriverApp/driver-tracing'),
    //       name: 'DriverTracing',
    //       meta: { title: 'DriverTracing' }
    //     }
    //   ]
    // }
  ]
}

export default driverRouter
